import { render, staticRenderFns } from "./CompanyColors.vue?vue&type=template&id=03df78e3"
import script from "./CompanyColors.vue?vue&type=script&lang=js"
export * from "./CompanyColors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports